import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-bootstrap'
import HoldTimer from './holdTimer'
import WarningModal from '../components/modals/WarningModal'
import { connect } from 'react-redux'
import {
  unlockRooms,
  logout,
  loadBookingStatusFromCache,
  loadHoldStatus,
  resetRoomBookingState
} from '../redux/actions'
import autobind from 'autobind-decorator'

import LoadingBar, { showLoading, hideLoading } from 'react-redux-loading-bar'
import $ from 'jquery'
import Notifications, { notify } from 'react-notify-toast'
import Navigation from '../components/navigation'
import TestVersionWarning from '../components/topBars/testVersionWarning'
import ProgramBookingBar from '../components/topBars/programBookingBar'
import {
  isProgramBookingSelector,
  exitProgramBooking,
  programDetailsSelector
} from '../redux/modules/searchParamsModule'
import { permissionsSelector } from '../redux/selectors/authSelector'
import { resetErrorValues } from '../redux/modules/errorDialogModule'
import CoronavirusNotice from '../components/topBars/coronavirusNotice'
import { withRouter } from 'react-router'
import history from '../history'

@autobind
class Root extends Component {
  constructor(props) {
    super(props)
    this.state = { navExpanded: false }
  }

  static propTypes = {
    dispatch: PropTypes.func,
    children: PropTypes.object,
    auth: PropTypes.object
  }

  componentWillUnmount() {
    const { dispatch } = this.props
    $(document).off('ajaxStart', () => {
      console.log('----ajax start off .....')
      dispatch(showLoading())
    })
    $(document).off('ajaxStop', () => {
      console.log('----ajax stop off.....')
      dispatch(hideLoading())
    })
  }

  handleSearchRestartClick() {
    this.props.dispatch(resetRoomBookingState())
  }

  handleDashboardClick() {
    this.props.dispatch(resetRoomBookingState())
  }

  logout(event) {
    if (event) {
      event.preventDefault()
      this.props.dispatch(logout())
      history.push('/search')
    }
  }

  login(event) {
    if (event) {
      event.preventDefault()
      const path = this.props.location.pathname
      if (path === '/guestentry' || path === '/payment') {
        this.props.dispatch(this.props.dispatch(unlockRooms))
      }
      history.push('/login')
    }
  }

  componentWillMount() {
    // checks for isAuthenticated for every request
    const {
      dispatch,
      history: { prevPage },
      bookingDetails: { currentState },
      location: { pathname }
    } = this.props
    if (!prevPage || prevPage == '') {
      if (currentState == 'NONE') {
        this.props.dispatch(loadBookingStatusFromCache())
      }
      if (pathname === '/guestentry' || pathname === '/payment') {
        this.props.dispatch(loadHoldStatus())
      }
    }
    $(document).on('ajaxStart', () => {
      console.log('----ajax start .....')
      dispatch(showLoading())
    })
    $(document).on('ajaxComplete', () => {
      console.log('----ajax stop .....')
      dispatch(hideLoading())
    })
    $(document).ajaxSuccess(function(event, xhr, settings) {
      console.log('Triggered ajaxSuccess handler. ', settings.url)
    })
    $(document).ajaxError(function(event, xhr, settings, thrownError) {
      console.log('Triggered ajax failure .... ', settings.url)
      if (thrownError == 'Unauthorized') {
        if (settings.url.indexOf('/login') < 0) {
          notify.show('Your session has been logged out..', 'error', 3000, {
            background: '#8f3416',
            text: '#FFFFFF'
          })
          dispatch(logout(true))
        }
      } else {
        notify.show(
          'There was an error with booking your room. Please contact ' +
            extConfig.SUPPORT_CONTACT +
            ' to complete your booking.',
          'error',
          3000,
          { background: '#8f3416', text: '#FFFFFF' }
        )
      }
    })
  }

  setNavExpanded(expanded) {
    this.setState({ navExpanded: expanded })
  }

  closeNav() {
    this.setState({ navExpanded: false })
  }

  setNavState() {
    if (this.state.navExpanded) this.setState({ navExpanded: false })
    else this.setState({ navExpanded: true })
  }

  render() {
    const {
      auth: { authenticated },
      formErrors: { messages, popupError },
      isProgramBooking,
      programDetails,
      showRoomScreen,
      dispatch
    } = this.props
    const path = this.props.location.pathname
    return (
      <div>
        <LoadingBar className='ajax-loading' />
        {extConfig.IS_TEST_VERSION === 'true' ? <TestVersionWarning /> : null}

        {isProgramBooking ? (
          <ProgramBookingBar
            {...programDetails}
            onCancelButtonClick={() =>
              dispatch(exitProgramBooking({ redirect: true }))
            }
          />
        ) : null}

        <Col lg={8} md={6} sm={6} xs={6}>
          <Notifications />
        </Col>
        {this.props.loadingBar > 0 ? <div className='overlay' /> : null}
        <Navigation
          path={path}
          authenticated={authenticated}
          setNavExpanded={this.setNavExpanded}
          navExpanded={this.state.navExpanded}
          setNavState={this.setNavState}
          closeNav={this.closeNav}
          handleSearchRestartClick={this.handleSearchRestartClick}
          handleDashboardClick={this.handleDashboardClick}
          logout={this.logout}
          showRoomScreen={showRoomScreen}
        />
        <Grid>
          <Row>
            <Col lg={12} xs={12}>
              <HoldTimer />
              {this.props.children}
            </Col>
          </Row>
        </Grid>
        <WarningModal
          messages={messages}
          popupError={popupError}
          onClose={() => dispatch(resetErrorValues())}
        />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    auth: state.common.authentication,
    formErrors: state.common.formErrors,
    loadingBar: state.loadingBar,
    bookingDetails: state.common.bookingDetails,
    isProgramBooking: isProgramBookingSelector(state),
    programDetails: programDetailsSelector(state),
    showRoomScreen: permissionsSelector(state).roomScreen
  }
}

// const mapDispatchToProps = {
//  onExitProgramBooking: exitProgramBooking
// }

export default withRouter(connect(mapStateToProps)(Root))



// WEBPACK FOOTER //
// ./src/containers/root.js